/* Vverd · Esteira de brindes (Black 2026, etapa 2): coloca e tira os brindes do carrinho sozinho.
   Regras (as mesmas da barra, lidas do bloco #ve-config que o snippet vverd-esteira desenha):
   - Brindes cumulativos: cada faixa atingida ganha o seu presente, 1 unidade de cada.
   - Base: só produtos das marcas listadas, sem os brindes, depois dos descontos
     (por produto e, proporcionalmente, no pedido), sem frete.
   - Brinde esgotado não entra (vale enquanto durar o estoque).
   Roda ao abrir qualquer página, ao voltar para a aba e a cada mudança do carrinho feita pelo tema,
   e faz uma última conferência ao clicar em Finalizar compra. */
(function () {
  if (window.__veEsteira) return;
  window.__veEsteira = true;

  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ocupado = false;
  var denovo = false;
  var esgotado = {};
  var espera = null;

  function config() {
    var el = document.getElementById('ve-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function json(url, corpo) {
    return fetch(raiz + url, {
      method: corpo ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: corpo ? JSON.stringify(corpo) : undefined
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) { var e = new Error(d.description || r.status); e.status = r.status; throw e; } return d; });
    });
  }

  /* Valor que conta para a faixa, igual ao cálculo do snippet. */
  function base(cart, cfg) {
    var marcas = cfg.marcas, brindes = cfg.faixas.map(function (f) { return f.v; });
    var b = 0;
    cart.items.forEach(function (i) {
      if (brindes.indexOf(i.variant_id) > -1) return;
      if (marcas.indexOf(String(i.vendor || '').trim().toUpperCase()) < 0) return;
      b += i.final_line_price;
    });
    var desc = 0;
    (cart.cart_level_discount_applications || []).forEach(function (d) { desc += d.total_allocated_amount || 0; });
    if (desc > 0 && cart.items_subtotal_price > 0 && b > 0) b -= Math.floor(b * desc / cart.items_subtotal_price);
    return b;
  }

  /* Lista de ações para deixar o carrinho com os brindes certos. */
  function plano(cart, cfg) {
    var b = base(cart, cfg);
    var linhas = {};
    cart.items.forEach(function (i) { (linhas[i.variant_id] = linhas[i.variant_id] || []).push(i); });
    var pagos = cart.items.some(function (i) {
      return !cfg.faixas.some(function (f) { return f.v === i.variant_id; });
    });
    var tirar = [], ajustar = [], por = [];
    cfg.faixas.forEach(function (f) {
      var quer = cfg.ativo && pagos && b >= f.min && !esgotado[f.v] ? 1 : 0;
      var ls = linhas[f.v] || [];
      if (!quer) { ls.forEach(function (l) { tirar.push(l.key); }); return; }
      if (!ls.length) { por.push(f.v); return; }
      ls.forEach(function (l, n) {
        if (n > 0) tirar.push(l.key);
        else if (l.quantity !== 1) ajustar.push(l.key);
      });
    });
    return { tirar: tirar, ajustar: ajustar, por: por };
  }

  /* Redesenha a gaveta e o ícone do carrinho sem abrir a gaveta. */
  function redesenhar() {
    return fetch(raiz + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var p = new DOMParser();
        var novo = s['cart-drawer'] && p.parseFromString(s['cart-drawer'], 'text/html').querySelector('.drawer__inner');
        var atual = document.querySelector('cart-drawer .drawer__inner');
        if (novo && atual) atual.innerHTML = novo.innerHTML;
        var bolha = s['cart-icon-bubble'] && p.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        var icone = document.getElementById('cart-icon-bubble');
        if (bolha && icone) icone.innerHTML = bolha.innerHTML;
        var gaveta = document.querySelector('cart-drawer');
        if (gaveta) gaveta.classList.toggle('is-empty', !document.querySelector('cart-drawer .cart-item'));
      })
      .catch(function () {});
  }

  function executar(p) {
    var passos = Promise.resolve();
    p.tirar.forEach(function (k) { passos = passos.then(function () { return json('cart/change.js', { id: k, quantity: 0 }); }); });
    p.ajustar.forEach(function (k) { passos = passos.then(function () { return json('cart/change.js', { id: k, quantity: 1 }); }); });
    if (p.por.length) {
      passos = passos.then(function () {
        return json('cart/add.js', { items: p.por.map(function (v) { return { id: v, quantity: 1, properties: { _brinde: 'Esteira de presentes' } }; }) })
          .catch(function (e) {
            /* 422 = sem estoque: tenta um por um e marca o que esgotou. */
            if (e.status !== 422) throw e;
            var um = Promise.resolve();
            p.por.forEach(function (v) {
              um = um.then(function () {
                return json('cart/add.js', { items: [{ id: v, quantity: 1, properties: { _brinde: 'Esteira de presentes' } }] })
                  .catch(function () { esgotado[v] = 1; });
              });
            });
            return um;
          });
      });
    }
    return passos;
  }

  /* Trava entre abas: com várias abas da loja abertas, só uma mexe no carrinho por vez.
     Sem ela, cada aba via "falta o brinde" ao mesmo tempo e somava 1 unidade, e o brinde chegava ao checkout com 7. */
  var aba = Math.random().toString(36).slice(2);
  function pegarTrava() {
    try {
      var t = (localStorage.getItem('ve-trava') || '').split(':');
      if (t[1] && t[1] !== aba && Date.now() - Number(t[0]) < 5000) return false;
      localStorage.setItem('ve-trava', Date.now() + ':' + aba);
    } catch (e) {}
    return true;
  }
  function soltarTrava() {
    try { if ((localStorage.getItem('ve-trava') || '').split(':')[1] === aba) localStorage.removeItem('ve-trava'); } catch (e) {}
  }

  /* Confere o carrinho e corrige os brindes. Depois de mexer, confere de novo para garantir 1 unidade de cada. */
  function rodar(voltas) {
    var cfg = config();
    if (!cfg) return Promise.resolve(false);
    return json('cart.js').then(function (cart) {
      var p = plano(cart, cfg);
      if (!p.tirar.length && !p.ajustar.length && !p.por.length) return false;
      return executar(p).then(function () {
        return voltas > 0 ? rodar(voltas - 1).then(function () { return true; }) : true;
      });
    });
  }

  function conferir() {
    if (!config()) return;
    if (ocupado) { denovo = true; return; }
    if (!pegarTrava()) { clearTimeout(espera); espera = setTimeout(conferir, 1500); return; }
    ocupado = true;
    rodar(2).then(function (mudou) {
      if (!mudou) return;
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      return redesenhar();
    }).catch(function () {}).then(function () {
      ocupado = false;
      soltarTrava();
      if (denovo) { denovo = false; agendar(); }
    });
  }

  /* Antes de ir para o checkout, uma última conferência (espera terminar). */
  function guardarCheckout(e) {
    var b = e.target.closest && e.target.closest('#CartDrawer-Checkout, #checkout, button[name="checkout"], input[name="checkout"]');
    if (!b || !config() || b.getAttribute('data-ve-ok')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    b.setAttribute('aria-busy', 'true');
    var esperar = function (n) {
      return ocupado && n > 0 ? new Promise(function (r) { setTimeout(r, 300); }).then(function () { return esperar(n - 1); }) : Promise.resolve();
    };
    esperar(20).then(function () { return rodar(2); }).catch(function () {}).then(function () {
      location.href = raiz + 'checkout';
    });
  }

  function agendar() { clearTimeout(espera); espera = setTimeout(conferir, 150); }

  /* Bolha do ícone do carrinho: mostra só os produtos pagos (o tema conta os brindes junto). */
  function bolha() {
    var cfg = config();
    if (!cfg || typeof cfg.pagos !== 'number') return;
    var b = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!b) return;
    var n = cfg.pagos;
    if (n === 0) { if (b.style.display !== 'none') b.style.display = 'none'; return; }
    if (b.style.display === 'none') b.style.display = '';
    var num = b.querySelector('span[aria-hidden]');
    if (num && num.textContent !== String(n)) num.textContent = n;
    var leitor = b.querySelector('.visually-hidden');
    var txt = n + (n === 1 ? ' item' : ' itens');
    if (leitor && leitor.textContent !== txt) leitor.textContent = txt;
  }
  /* Celular: a barra fixa "Total + Finalizar" some quando o botão principal aparece na rolagem. */
  var vigiaFixo = null, botaoVigiado = null;
  function ligarFixo() {
    var fixo = document.querySelector('cart-drawer .vc-fixo');
    var botao = document.getElementById('CartDrawer-Checkout');
    var caixa = document.querySelector('cart-drawer .drawer__inner');
    if (!fixo || !botao || !caixa || !('IntersectionObserver' in window)) return;
    if (botao === botaoVigiado) return;
    if (vigiaFixo) vigiaFixo.disconnect();
    botaoVigiado = botao;
    vigiaFixo = new IntersectionObserver(function (e) {
      var f = document.querySelector('cart-drawer .vc-fixo');
      if (f) f.classList.toggle('is-oculto', e[0].isIntersecting);
    }, { root: caixa, threshold: 0.6 });
    vigiaFixo.observe(botao);
  }
  /* Previsão de entrega: hoje + N dias úteis (sem sábado e domingo), no fuso de São Paulo. */
  function diaUtil(n) {
    var d = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' }));
    var c = 0;
    while (c < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) c++; }
    return d.toLocaleDateString('pt-BR', { weekday: 'short', day: '2-digit', month: '2-digit' }).replace('.', '');
  }
  function prazo() {
    document.querySelectorAll('cart-drawer [data-vc-prazo]').forEach(function (el) {
      if (el.getAttribute('data-vc-ok')) return;
      var t = el.querySelector('[data-vc-prazo-texto]');
      var min = parseInt(el.getAttribute('data-min'), 10), max = parseInt(el.getAttribute('data-max'), 10);
      if (!t || !min || !max) return;
      el.setAttribute('data-vc-ok', '1');
      t.textContent = 'Chega entre ' + diaUtil(min) + ' e ' + diaUtil(max);
    });
  }
  function vigiarBolha() {
    if (!('MutationObserver' in window)) return;
    var obs = new MutationObserver(function () { bolha(); ligarFixo(); prazo(); });
    var icone = document.getElementById('cart-icon-bubble');
    var gaveta = document.querySelector('cart-drawer');
    if (icone) obs.observe(icone, { childList: true, subtree: true, characterData: true });
    if (gaveta) obs.observe(gaveta, { childList: true, subtree: true });
    bolha();
    ligarFixo();
    prazo();
  }

  function ligar() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, agendar);
    }
    conferir();
    vigiarBolha();
    document.addEventListener('click', guardarCheckout, true);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') agendar(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) agendar(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligar);
  else ligar();
})();
